module.exports = __webpack_public_path__ + "img/banner_bg@3x.0519c1ab.png";